<div theme  [styleObj]="current | async">
  <app-nav-bar [ReadApr]="ReadApr" [ReadDocuments]="ReadDocuments" [ReadStudentSearch]="ReadStudentSearch" [ReadSummary]="ReadSummary" [ReadCertification]="ReadCertification" [ReadMaintenance]="ReadMaintenance"
  [ReadReports]="ReadReports"
  > 
</app-nav-bar>
<app-loading *ngIf="showLoading"></app-loading>   
<div class="container" style="min-height: 100vh;">
    <router-outlet></router-outlet>   
</div>  
<app-footer></app-footer>
</div>